import React, { useState, useEffect, useRef } from "react";
import { apiUrl } from "../utils/api";
import "../styles/Products.css";

const QuotationForm = ({ productName, productImage, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    product_name: productName || "",
    quantity: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false); // synchronous guard against double-clicks

  useEffect(() => {
    setFormData((prev) => ({ ...prev, product_name: productName || "" }));
  }, [productName]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submittingRef.current) return; // already submitting — ignore extra clicks
    submittingRef.current = true;
    setIsSubmitting(true);

    try {
      const res = await fetch(apiUrl("/quotes"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        alert(`Quotation request submitted for ${productName}! We will contact you soon.`);
        setFormData({
          name: "",
          email: "",
          phone: "",
          product_name: productName || "",
          quantity: "",
          message: "",
        });
        onClose();
      } else {
        alert("Failed to submit. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Server error. Try again later.");
    } finally {
      submittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={() => !isSubmitting && onClose()}>
      <div className="modal quote-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="close-btn"
          onClick={onClose}
          disabled={isSubmitting}
        >
          &times;
        </button>

        <div className="quote-product-panel">
          <h2>Request Quotation for <br />{productName}</h2>
          {productImage && (
            <img
              className="quote-product-image"
              src={productImage}
              alt={productName}
            />
          )}
        </div>

        <form className="quote-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleInputChange}
            disabled={isSubmitting}
          />
          <input
            type="text"
            name="product_name"
            value={formData.product_name}
            readOnly
          />
          <input
            type="number"
            name="quantity"
            placeholder="Quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            required
            disabled={isSubmitting}
          />
          <textarea
            name="message"
            placeholder="Message / Requirements"
            value={formData.message}
            onChange={handleInputChange}
            disabled={isSubmitting}
          ></textarea>
          <div className="modal-actions">
            <button type="submit" className="quote-btn" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuotationForm;